/**
 * Permission codes the attention screens declare an interest in
 * (`internal/attention/permissions.go`, design §6.1).
 *
 * `attention.item.read` is granted to `RoleEmployee` — everyone has an attention
 * list — and that is precisely why the endpoint takes **no principal
 * parameter**: the code answers "may this person read an attention list?" when
 * the question is "may they read *this* list?". The service resolves the user
 * from the JWT and has no path that accepts one, so there is nothing here to
 * scope and nothing to leak.
 *
 * `attention.policy.manage` is a separate, administrative code: deciding that
 * approval assignments are digested daily rather than emailed immediately
 * changes what every colleague receives.
 */

export const ATTENTION_PERMISSIONS = {
  itemRead: 'attention.item.read',
  policyManage: 'attention.policy.manage',
} as const

export type AttentionPermission =
  (typeof ATTENTION_PERMISSIONS)[keyof typeof ATTENTION_PERMISSIONS]
